import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const titleStyles = ({ theme }) => css`
  label: modal__title;

  font-size: ${theme.typography.headings.mega.fontSize};
  line-height: ${theme.typography.headings.mega.lineHeight};
  font-weight: ${theme.font.weight.semibold};
`

const titleRegionStyles = ({ theme }) => css`
  label: modal__title__region;

  color: ${theme.colors.p500};
`

const subtitleStyles = ({ theme }) => css`
  label: modal__subtitle;

  color: ${theme.colors.n400};
`

const sellerStyles = ({ theme }) => css`
  label: modal__seller;

  padding: ${theme.spacings.mega} 0;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${theme.colors.n100};
  }
`

const sellerNameStyles = ({ theme }) => css`
  label: seller__name;

  font-size: ${theme.typography.headings.kilo.fontSize};
  line-height: ${theme.typography.headings.kilo.lineHeight};
  font-weight: ${theme.font.weight.semibold};
`

const modalStyles = ({ theme }) => css`
  label: modal;

  height: auto;
  min-height: 0px;
  max-height: 100%;

  background: ${theme.colors.white};

  display: flex;
  flex-direction: column;

  border-radius: ${theme.borderRadius.mega};
  box-shadow: 0px 0px 0px 1px ${theme.colors.shadow},
    0px 0px 1px 0px ${theme.colors.shadow},
    0px 2px 2px 0px ${theme.colors.shadow};

  padding: ${theme.spacings.mega} 0px;
`

const modalHeaderStyles = ({ theme }) => css`
  label: modal__header;
  padding: ${theme.spacings.mega} ${theme.spacings.giga};
  padding-top: 0;
`

const modalBodyStyles = ({ theme }) => css`
  label: modal__body;

  padding: 0px ${theme.spacings.giga};
  height: 100%;
  min-height: 0px;
  flex: 1;
  overflow-y: auto;
`

export const ModalBody = styled('div')(modalBodyStyles)
export const Title = styled('div')(titleStyles)
export const TitleRegion = styled('span')(titleRegionStyles)
export const Subtitle = styled(Text)(subtitleStyles)
export const Seller = styled('div')(sellerStyles)
export const SellerName = styled('span')(sellerNameStyles)
export const Modal = styled('div')(modalStyles)
export const ModalHeader = styled('div')(modalHeaderStyles)
